require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _require = require('react'),
    useEffect = _require.useEffect,
    useRef = _require.useRef;

var useAsyncEffect = function useAsyncEffect(effect, destroy, inputs) {
  var hasDestroy = typeof destroy === 'function';
  var mounted = useRef();
  useEffect(function () {
    mounted.current = true;
    var result;
    var maybePromise = effect(function () {
      return mounted.current;
    });
    Promise.resolve(maybePromise).then(function (value) {
      result = value;
    });
    return function () {
      mounted.current = false;

      if (hasDestroy) {
        destroy(result);
      }
    };
  }, hasDestroy ? inputs : destroy);
};

module.exports = useAsyncEffect;
module.exports.useAsyncEffect = useAsyncEffect;